<script>
import Vue from 'vue'
import { bApp, termsBtnText } from 'base/config'
import Sliding from 'base/sliding/sliding'
import ListView from 'base/listview/listview'
import { clause, clauseSwitch, liabilities, getPublicClause } from 'api/index'
import { pbfUrl } from 'api/config'
import { Popup } from 'bxs-ui-vue'
import ToggleDesc from 'components/toggleDesc/toggleDesc'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  loop: false,
  fullscreenEl: false,
  zoomEl: false
})

const pbfSearchBase = `${pbfUrl}/planBook/termsSearch/pages`
const VISIBLE_COUNT = 2
export default {
  name: 'TermsList',
  components: {
    Sliding,
    ListView,
    ToggleDesc,
    [Popup.name]: Popup
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false
    },
    propUuid: {
      type: String
    },
    propName: {
      type: String,
      default: ''
    },
    propId: {
      type: Number
    },
    miniprogram: {
      type: Boolean,
      default: false
    }
  },
  data () {
    this.isApp = bApp
    this.btnText = termsBtnText
    this.searchUrl = `${pbfSearchBase}/index.html?nw=1`
    return {
      terms: {
        show: false,
        list: []
      },
      termsDetailList: [],
      termsListShow: [],
      visible: false,
      isSupportShow: false
    }
  },
  computed: {
    codeVisible () {
      const { terms } = this
      if (!Array.isArray(terms.list)) return
      const codeList = terms.list.filter(item => {
        return item.code
      })
      return !!codeList.length
    },
    isLenAttain () {
      const {
        terms: { list }
      } = this
      return list.length > VISIBLE_COUNT
    },
    visibleList () {
      const {
        terms: { list },
        visible,
        isLenAttain
      } = this
      if (!Array.isArray(list)) return []
      const showList = list.filter(item => item.clauseUrl)
      return isLenAttain
        ? visible
          ? showList
          : showList.slice(0, VISIBLE_COUNT)
        : showList
    },
    isShow () {
      const { visibleList } = this
      return Array.isArray(visibleList) && visibleList.length
    }
  },
  watch: {
    propUuid: {
      handler () {
        this.terms.list = []
      }
    },
    propId: {
      handler (value) {
        const { terms } = this
        if (!Array.isArray(terms.list) || !value) return
        let index = 0
        for (let i = 0, len = terms.list.length; i < len; i++) {
          if (terms.list[i].id === value) {
            index = i
            break
          }
        }
        this.handleView(terms.list[index], index)
      }
    }
  },
  created () {
    this.getClause()
    // this.setClauseView()
  },
  mounted () {
    this.$previewRefresh()
  },
  methods: {
    syncHandleView (item, index) {
      this.terms.show = true
      // if (this.termsListShow[index]) {
      //   this.termsListShow[index] = false
      // }
      this.syncHandleOpen({ item, index })
    },
    asyncClose () {
      this.terms.show = false
      this.$emit('close')
    },
    handleView (item, index) {
      this.terms.show = true
      this.syncDelta({ pbData: { isClausesShow: true } })
      if (this.termsListShow[index]) return
      this.handleOpen({ item, index })
    },
    syncHandleOpen ({ item, index } = {}) {
      const { termsListShow, termsDetailList } = this
      if (termsDetailList[index]) {
        this.termsListShow.splice(index, 1, !termsListShow[index])
        return
      }

      liabilities({}, `${item.id}/liabilities`).then(
        ({ data: { success, data } } = { data: {} }) => {
          if (success) {
            this.termsDetailList.splice(index, 1, data)
            this.termsListShow.splice(index, 1, true)
            this.$nextTick(() => {
              this.$previewRefresh()
            })
          }
        }
      )
    },
    handleOpen ({ item, index } = {}) {
      this.syncDelta({
        pbData: {
          isClausesShow: true,
          isClausesDetailShow: {
            isShow: !this.termsListShow[index],
            index
          }
        }
      })
      this.syncHandleOpen({ item, index })
    },
    handleClose () {
      this.terms.show = false
      this.$emit('close')
      this.syncDelta({ pbData: { isClausesShow: false } })
    },
    handleShowImg (list, idx) {
      if (appBridge && appBridge.checkAppFeature('NATIVE_IMAGE_VIEWER')) {
        const urls = list.map(item => {
          return item.picUrl
        })
        appBridge.showImageViewer({ urls, idx }).catch(function (e) {
          console.log(e.name + '  ' + e.message)
        })
      }
    },
    handleToggle (visible) {
      this.visible = visible
    },
    syncToggle () {
      const visible = !this.visible
      this.handleToggle(visible)
      this.syncDelta({ pbData: { isClausesAllShow: visible } })
    },
    handleViewClause ({ clauseUrl, name }) {
      const index = clauseUrl.lastIndexOf('.')
      const ext = clauseUrl.substr(index + 1)
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const isLegalDomain = /\.winbaoxian\.cn|\.winbaoxian\.com/.test(clauseUrl)
      // 小程序且非站内域名
      if (this.miniprogram && !isLegalDomain) {
        this.isSupportShow = true
        this.terms.show = false
        return
      }
      if (!this.isApp && isAndroid && ext == 'pdf') {
        let targetURL = `${pbfUrl}/planBook/planbookAccessories/pdf-viewer/index.html?file=${encodeURIComponent(
          clauseUrl
        )}`
        if (name) {
          targetURL += `&title=${name}`
        }
        location.href = targetURL
        return
      }
      location.href = `${clauseUrl}?nw=1`
    },
    getClause () {
      const {
        isPublic,
        propUuid,
        terms: { list }
      } = this
      const fetch = isPublic ? getPublicClause : clause
      if (list.length === 0 && propUuid) {
        fetch({ uuid: propUuid }).then(
          ({ data: { success, data } } = { data: {} }) => {
            if (success) {
              const _data = this.transformData(data)
              const _len = _data.length
              this.terms.list = _data
              this.termsListShow.length = _len
              this.termsDetailList.length = _len
              // this.$nextTick(() => {
              //   this.terms.show = true
              // })
            }
          }
        )
      } else {
        // this.terms.show = true
      }
    },
    setClauseView () {
      if (!this.propUuid) return
      clauseSwitch().then(({ data: { success, data } } = { data: {} }) => {
        if (!success) return
        this.isAndroidView = data
      })
    },
    transformData (ary) {
      if (!Array.isArray(ary) || !ary.length) return []
      const { propName } = this
      ary.forEach((item, index) => {
        if (item) {
          ary[index].href = `${pbfSearchBase}/terms.html?termsId=${
            item.id
          }&nw=1${propName ? '&name=' + encodeURIComponent(propName) : ''}`
        } else {
          ary.splice(index)
        }
      })
      return ary
    }
  }
}
</script>

<template>
  <div v-if="isShow" class="terms-wrap">
    <div class="terms-box">
      <h3 class="after-bd-b">
        {{ btnText }}
      </h3>
      <div class="bd">
        <div
          v-for="(item, index) in visibleList"
          :key="index"
          class="terms-item"
        >
          <div class="terms-item-title">
            <p>{{ item.fullName }}</p>
          </div>
          <div class="terms-item-btn">
            <a
              v-if="item.clauseUrl"
              class="after-bdr"
              href="javascript:;"
              data-stat-id="tkxq_yw"
              @click="handleViewClause(item)"
            >原文</a>
            <a
              class="after-bdr"
              href="javascript:;"
              data-stat-id="tkxq_yl"
              @click="handleView(item, index)"
            >预览</a>
          </div>
        </div>
        <toggle-desc
          v-if="isLenAttain"
          class="normal-toggle"
          @toggle="syncToggle"
        />
      </div>
    </div>
    <sliding
      :show="terms.show"
      :over-height="false"
      :title="'条款列表'"
      iconfont="icon-close_line"
      @close="handleClose"
    >
      <div class="scroll-wrap">
        <div class="scroll-top">
          <i class="iconfont icon-inform" />条款内容均来源于网络
        </div>
        <div class="scroll-main">
          <div class="terms-container">
            <list-view
              class="terms-list"
              :list-data="terms.list"
              :class="{ 'no-code': !codeVisible }"
            >
              <template slot="item" slot-scope="props">
                <li>
                  <div
                    class="link cell-box after-bd-b"
                    data-stat-id="list"
                    :data-stat-ep="JSON.stringify({ id: props.item.id })"
                    @click="handleOpen(props)"
                  >
                    <div class="pre-wrap">
                      <div class="pre">
                        {{ props.item.code || ' - -' }}
                      </div>
                    </div>
                    <div
                      class="info-wrap"
                      :class="[
                        termsListShow[props.index] ? 'assert-b' : 'assert-t',
                      ]"
                    >
                      <div class="info">
                        <h4>
                          <span class="name">{{ props.item.fullName }}</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      termsListShow[props.index] &&
                        (props.item.clauseUrl ||
                          termsDetailList[props.index].length)
                    "
                    class="liabilities-pic"
                  >
                    <div
                      v-if="termsListShow[props.index] && props.item.clauseUrl"
                      class="original-link"
                    >
                      <a
                        :title="props.item.name"
                        data-stat-id="tkxq_yw"
                        href="javascript:;"
                        @click="handleViewClause(props.item)"
                      >
                        <h6>条款预览</h6>
                        <div class="view assert-r">查看条款原文</div>
                      </a>
                    </div>
                    <template
                      v-if="
                        termsListShow[props.index] &&
                          termsDetailList[props.index].length
                      "
                    >
                      <template v-if="isApp">
                        <div
                          v-for="(pic, index) in termsDetailList[props.index]"
                          :key="'k' + props.index + index"
                          class="liab-img"
                          @click="
                            handleShowImg(termsDetailList[props.index], index)
                          "
                        >
                          <img :src="pic.picUrl" :alt="pic.id">
                          <i class="zoom-in" />
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-for="(pic, index) in termsDetailList[props.index]"
                          :key="'k' + props.index + index"
                          class="liab-img"
                        >
                          <img
                            :src="pic.picUrl"
                            :alt="pic.id"
                            :preview="props.index"
                            :large="pic.picUrl"
                          >
                          <i class="zoom-in" />
                        </div>
                      </template>
                    </template>
                  </div>
                </li>
              </template>
              <template v-if="isApp" slot="aftItem">
                <li class="more">
                  <a :href="searchUrl" data-stat-id="more">
                    <span class="assert-r">搜索更多条款</span>
                  </a>
                </li>
              </template>
            </list-view>
          </div>
        </div>
      </div>
    </sliding>

    <bxs-popup
      v-model="isSupportShow"
      class="not-support-miniprogram"
      :close-on-click-overlay="false"
    >
      <div class="tips">
        由于小程序域名限制，暂不支持查看该条款，请下载使用保险师app
      </div>
      <div class="btn" @click="isSupportShow = false">
        知道了
      </div>
    </bxs-popup>
  </div>
</template>

<style scoped>
@import 'variable';

.scroll-wrap {
  position: relative;
  height: 100%;
  .scroll-top {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.72rem;
    line-height: 0.72rem;
    padding: 0 0.84rem;
    background-color: #fffeed;
    font-size: 0.24rem;
    font-weight: bold;
    color: #666;
    .iconfont {
      position: absolute;
      left: 0.3rem;
      top: 50%;
      transform: translate(0, -50%);
      color: #ff9900;
      font-weight: normal;
    }
  }
  .scroll-main {
    height: 100%;
    border-top: 0.72rem solid #fff;
    overflow-y: auto;
  }
}

.terms-wrap {
  @apply --widthcenter;
  margin-bottom: 0.2rem;
  border-radius: 6px;
  background-color: #fff;
}

.terms-box {
  > h3 {
    position: relative;
    padding: 0.26rem 0;
    font-size: 0.34rem;
    font-weight: 700;
    text-align: center;
  }
  .bd {
    padding: 0.3rem;
  }
  .terms-item {
    display: flex;
    padding-left: 0.3rem;
    font-size: 0.32rem;
    &:not(:last-of-type) {
      margin-bottom: 0.3rem;
    }
  }
  .terms-item-title {
    flex: 1;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      left: -10px;
      top: 8px;
      border-width: 3px;
      border-style: solid;
      border-radius: 50%;
      vertical-align: middle;
    }
    > p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #333;
    }
  }
  .terms-item-btn {
    width: 2.3rem;
    text-align: right;
    > a {
      z-index: 1;
      display: inline-block;
      padding: 0.1rem 0.2rem 0.06rem;
      font-size: 0.24rem;
      font-weight: normal;
      line-height: 1;
      &:before {
        @apply --extend-click;
      }
      &:after {
        border-radius: 100px;
      }
      &:last-child {
        margin-left: 0.18rem;
      }
    }
  }
}

.terms-list {
  > li {
    overflow: hidden;
    /* &:after {
        left: 15px;
      } */
  }
  .link {
    width: 100%;
    padding-right: 0.3rem;
    display: block;
    overflow: hidden;
    -webkit-tap-highlight-color: transparent;
    background-color: #f8f8f8;
    .assert-t:after {
      margin-top: 0;
    }
  }
  .pre-wrap {
    width: 1.3rem;
    height: 0.96rem;
    float: left;
    -webkit-box-flex: 1;
    display: -webkit-box;
    -webkit-box-align: center;
  }
  .pre {
    position: relative;
    width: 1.3rem;
    height: 1rem;
    padding-left: 0.3rem;
    line-height: 0.96rem;
    font-size: 0.28rem;
    color: #999;
    @apply --text-ellipsis;
  }
  .info-wrap {
    position: relative;
    width: 100%;
    padding-left: 1.3rem;
    &:after {
      border-color: #ccc;
    }
  }
  .info {
    position: relative;
    width: 100%;
    padding: 0.22rem 0.3rem 0.22rem 0.2rem;
    & h4 {
      position: relative;
      width: 100%;
      display: block;
      overflow: hidden;
      padding-right: 0.2rem;
      font-size: 0.28rem;
      color: #333;
      font-weight: 400;
      line-height: 0.52rem;
    }
  }
  .more {
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    & a {
      display: block;
      color: var(--nine-color);
      font-size: 0.24rem;
    }
    & span {
      padding-right: 0.3rem;
      &:after {
        width: 6px;
        height: 6px;
        margin-top: -3px;
        border-color: var(--nine-color);
      }
    }
  }
  .liabilities-pic {
    padding: 0 0.3rem 0.3rem;
    .liab-img {
      position: relative;
      .zoom-in {
        z-index: 10;
        position: absolute;
        right: 0.3rem;
        bottom: 0.3rem;
        width: 0.48rem;
        height: 0.48rem;
        background: url(//img.winbaoxian.com/autoUpload/planbook/i-zoomIn_29926dcc8752e63.png)
          no-repeat center;
        background-size: 0.48rem 0.48rem;
        pointer-events: none;
      }
      > img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
  .original-link {
    > a {
      display: block;
      overflow: hidden;
      color: #999;
      font-size: 0.26rem;
    }
    h6 {
      float: left;
      width: 1.04rem;
      height: 0.92rem;
      line-height: 0.92rem;
    }
    .view {
      position: relative;
      width: 100%;
      padding-left: 1.04rem;
      padding-right: 0.36rem;
      text-align: right;
      line-height: 0.92rem;
      &:after {
        width: 8px;
        height: 8px;
        right: 3px;
        margin-top: -3px;
        border-color: #ccc;
      }
    }
  }
  &.no-code {
    .pre-wrap {
      display: none;
    }
    .info-wrap {
      padding-left: 0;
    }
  }
}
</style>
